<template>
    <div class="centered-page not-found">
        <h3>404 - Page not found</h3>
        <router-link :to="{ name: 'Home' }" class='pill-button'><span>Go Home</span></router-link>
    </div>
</template>